module.exports = __webpack_public_path__ + "fonts/GT-Cinetype-Bold.91bd3554.eot";